// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2-Hu0","upload":"Small_upload__3Fupf","imageWrap":"Small_imageWrap__1Ft3N","removeBtn":"Small_removeBtn__1S8z2"};